module.exports = "<div class=\"delete-panel text-center font-22\">\n    คุณถูกเชิญออกจากโครงการนี้\n</div>\n"